let paths = {
  overscore: 'M20,8H4V4H20',
  underscore: 'M20,20H4V16H20',
  loadingSpinner:
    'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
};
export default paths;
